import { Component } from '@angular/core';
import { IonicPage, Platform } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SysconfigService } from '../../services/sysconfig.service';
import { AppConfig } from '../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-link-collection',
  templateUrl: 'link-collection.html',
})
export class LinkCollectionPage {
  greenUrl = [];
  counterfeitUrl = [];
  appUrl = '';
  serverUrl = '';
  registerUrl = '';
  constructor(
    private iab: InAppBrowser,
    private sysconfig: SysconfigService,
    private config: AppConfig,
    private platform: Platform,
  ) {
    this.platform.ready().then(() => {
      document.addEventListener('touchend', (e: TouchEvent) => {
        const now = Date.now();
        const last = (window as any).lastTap || 0;
        if (now - last < 300) {  // 双击间隔 < 300ms
          e.preventDefault();
          e.stopPropagation();
        }
        (window as any).lastTap = now;
      }, false);
    });
  }

  ionViewDidLoad() {
    this.sysconfig.getServiceHall().then(s => {
      this.serverUrl = s.CustomerServiceUrl;
    });
    this.getPlatformUrls();
  }

  getPlatformUrls() {
    let param = { deviceType: 'wap' };
    this.sysconfig.getPlatformUrls(param).then(s => {
      this.appUrl = s.Mobile[0];
      this.greenUrl = s.Normal;
      this.counterfeitUrl = s.Protected;
      if (s.RegisterUrls && s.RegisterUrls.length && this.greenUrl.length) {
        let code = s.RegisterUrls[0].split('ey=')[1];
        let url = this.greenUrl[0];
        this.registerUrl = url + '/?Key=' + code;
      }
    });
  }

  goPage(url) {
    if (!url) return;
    this.config.openUrl(url);
  }
}



// WEBPACK FOOTER //
// ./src/pages/link-collection/link-collection.ts